import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=14bedb23"
import script from "./navigation-item.ts?vue&type=script&lang=ts&external"
export * from "./navigation-item.ts?vue&type=script&lang=ts&external"
import style0 from "./navigation-item.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports